import React, { useEffect } from "react";

import estilo from "./styles/Sobre.module.css";

import foto from "../img/rossBTV.jpg";
import MetaDecorator from "../utils/MetaDecorator";

function Sobre() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  let informacion = [
    {
      dato: "Bryan Roselbet Ticona Valencia",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"></path>
        </svg>
      ),
    },
    {
      dato: "Técnico en computación e informática",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M2 7v1l11 4 9-4V7L11 4z"></path>
          <path d="M4 11v4.267c0 1.621 4.001 3.893 9 3.734 4-.126 6.586-1.972 7-3.467.024-.089.037-.178.037-.268V11L13 14l-5-1.667v3.213l-1-.364V12l-3-1z"></path>
        </svg>
      ),
    },
    {
      dato: "19 de Septiembre de 1995",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M7 11h2v2H7zm0 4h2v2H7zm4-4h2v2h-2zm0 4h2v2h-2zm4-4h2v2h-2zm0 4h2v2h-2z"></path>
          <path d="M5 22h14c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2h-2V2h-2v2H9V2H7v2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2zM19 8l.001 12H5V8h14z"></path>
        </svg>
      ),
    },
    {
      dato: "bryan1736b@gmail.com",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm0 2v.511l-8 6.223-8-6.222V6h16zM4 18V9.044l7.386 5.745a.994.994 0 0 0 1.228 0L20 9.044 20.002 18H4z"></path>
        </svg>
      ),
    },
    {
      dato: "+51 950 706 848",
      svg: (
        <svg width="24" height="24" viewBox="0 0 24 24">
          <path d="m20.487 17.14-4.065-3.696a1.001 1.001 0 0 0-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 0 0 .043-1.391L6.859 3.513a1 1 0 0 0-1.391-.087l-2.17 1.861a1 1 0 0 0-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 0 0 .648-.291l1.86-2.171a.997.997 0 0 0-.085-1.39z"></path>
        </svg>
      ),
    },
    {
      dato: "Lima, Perú",
      svg: (
        <svg width="24" height="24" viewBox="0 0 16 16">
          <path d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z" />
        </svg>
      ),
    },
  ];

  let educacion = [
    {
      año: "2008 - 2013",
      centro_estudios: "I.E Independencia del Perú",
      area: "Secundaria",
      estado: true,
    },
    {
      año: "2015 - 2017",
      centro_estudios: "Universidad Peruana los Andes",
      area: "Administracion de Empresas",
      estado: false,
    },
    {
      año: "2019 - 2023",
      centro_estudios: "CIMA'S",
      area: "Computación e Informática",
      estado: true,
    },
    {
      año: "2022 - 2023",
      centro_estudios: "Universidad Peruana de las Américas",
      area: "Ingles A1, A2, B1",
      estado: true,
    },
  ];

  let habilidades = [
    {
      nombre: "Html",
      link: "https://developer.mozilla.org/es/docs/Web/HTML",
      svg: (
        <svg width="150" height="150" viewBox="0 0 24 24">
          <path d="M4.136 3.012h15.729l-1.431 16.15-6.451 1.826-6.414-1.826-1.433-16.15zm5.266 7.302-.173-2.035 7.533.002.173-1.963-9.87-.002.522 5.998h6.835l-.243 2.566-2.179.602-2.214-.605-.141-1.58H7.691l.247 3.123L12 17.506l4.028-1.08.558-6.111H9.402v-.001z"></path>
        </svg>
      ),
    },
    {
      nombre: "Css",
      link: "https://developer.mozilla.org/es/docs/Web/CSS",
      svg: (
        <svg width="150" height="150" viewBox="0 0 24 24">
          <path d="M4.192 3.143h15.615l-1.42 16.034-6.404 1.812-6.369-1.813L4.192 3.143zM16.9 6.424l-9.8-.002.158 1.949 7.529.002-.189 2.02H9.66l.179 1.913h4.597l-.272 2.62-2.164.598-2.197-.603-.141-1.569h-1.94l.216 2.867L12 17.484l3.995-1.137.905-9.923z"></path>
        </svg>
      ),
    },
    {
      nombre: "Javascript",
      link: "https://developer.mozilla.org/es/docs/Web/JavaScript",
      svg: (
        <svg width="150" height="150" viewBox="0 0 24 24">
          <path d="M3 3h18v18H3V3zm16.525 13.707c-.131-.821-.666-1.511-2.252-2.155-.552-.259-1.165-.438-1.349-.854-.068-.248-.078-.382-.034-.529.113-.484.687-.629 1.137-.495.293.09.563.315.732.676.775-.507.775-.507 1.316-.844-.203-.314-.304-.451-.439-.586-.473-.528-1.103-.798-2.126-.775l-.528.067c-.507.124-.991.395-1.283.754-.855.968-.608 2.655.427 3.354 1.023.765 2.521.933 2.712 1.653.18.878-.652 1.159-1.475 1.058-.607-.136-.945-.439-1.316-1.002l-1.372.788c.157.359.337.517.607.832 1.305 1.316 4.568 1.249 5.153-.754.021-.067.18-.528.056-1.237l.034.049zm-6.737-5.434h-1.686c0 1.453-.007 2.898-.007 4.354 0 .924.047 1.772-.104 2.033-.247.517-.886.451-1.175.359-.297-.146-.448-.349-.623-.641-.047-.078-.082-.146-.095-.146l-1.368.844c.229.473.563.879.994 1.137.641.383 1.502.507 2.404.305.588-.17 1.095-.519 1.358-1.059.384-.697.302-1.553.299-2.509.008-1.541 0-3.083 0-4.635l.003-.042z"></path>
        </svg>
      ),
    },
    {
      nombre: "React",
      link: "https://react.dev/learn",
      svg: (
        <svg width="150" height="150" viewBox="0 0 24 24">
          <circle cx="12" cy="11.245" r="1.785"></circle>
          <path d="m7.002 14.794-.395-.101c-2.934-.741-4.617-2.001-4.617-3.452 0-1.452 1.684-2.711 4.617-3.452l.395-.1.111.391a19.507 19.507 0 0 0 1.136 2.983l.085.178-.085.178c-.46.963-.841 1.961-1.136 2.985l-.111.39zm-.577-6.095c-2.229.628-3.598 1.586-3.598 2.542 0 .954 1.368 1.913 3.598 2.54.273-.868.603-1.717.985-2.54a20.356 20.356 0 0 1-.985-2.542zm10.572 6.095-.11-.392a19.628 19.628 0 0 0-1.137-2.984l-.085-.177.085-.179c.46-.961.839-1.96 1.137-2.984l.11-.39.395.1c2.935.741 4.617 2 4.617 3.453 0 1.452-1.683 2.711-4.617 3.452l-.395.101zm-.41-3.553c.4.866.733 1.718.987 2.54 2.23-.627 3.599-1.586 3.599-2.54 0-.956-1.368-1.913-3.599-2.542a20.683 20.683 0 0 1-.987 2.542z"></path>
          <path d="m6.419 8.695-.11-.39c-.826-2.908-.576-4.991.687-5.717 1.235-.715 3.222.13 5.303 2.265l.284.292-.284.291a19.718 19.718 0 0 0-2.02 2.474l-.113.162-.196.016a19.646 19.646 0 0 0-3.157.509l-.394.098zm1.582-5.529c-.224 0-.422.049-.589.145-.828.477-.974 2.138-.404 4.38.891-.197 1.79-.338 2.696-.417a21.058 21.058 0 0 1 1.713-2.123c-1.303-1.267-2.533-1.985-3.416-1.985zm7.997 16.984c-1.188 0-2.714-.896-4.298-2.522l-.283-.291.283-.29a19.827 19.827 0 0 0 2.021-2.477l.112-.16.194-.019a19.473 19.473 0 0 0 3.158-.507l.395-.1.111.391c.822 2.906.573 4.992-.688 5.718a1.978 1.978 0 0 1-1.005.257zm-3.415-2.82c1.302 1.267 2.533 1.986 3.415 1.986.225 0 .423-.05.589-.145.829-.478.976-2.142.404-4.384-.89.198-1.79.34-2.698.419a20.526 20.526 0 0 1-1.71 2.124z"></path>
          <path d="m17.58 8.695-.395-.099a19.477 19.477 0 0 0-3.158-.509l-.194-.017-.112-.162A19.551 19.551 0 0 0 11.7 5.434l-.283-.291.283-.29c2.08-2.134 4.066-2.979 5.303-2.265 1.262.727 1.513 2.81.688 5.717l-.111.39zm-3.287-1.421c.954.085 1.858.228 2.698.417.571-2.242.425-3.903-.404-4.381-.824-.477-2.375.253-4.004 1.841.616.67 1.188 1.378 1.71 2.123zM8.001 20.15a1.983 1.983 0 0 1-1.005-.257c-1.263-.726-1.513-2.811-.688-5.718l.108-.391.395.1c.964.243 2.026.414 3.158.507l.194.019.113.16c.604.878 1.28 1.707 2.02 2.477l.284.29-.284.291c-1.583 1.627-3.109 2.522-4.295 2.522zm-.993-5.362c-.57 2.242-.424 3.906.404 4.384.825.47 2.371-.255 4.005-1.842a21.17 21.17 0 0 1-1.713-2.123 20.692 20.692 0 0 1-2.696-.419z"></path>
          <path d="M12 15.313c-.687 0-1.392-.029-2.1-.088l-.196-.017-.113-.162a25.697 25.697 0 0 1-1.126-1.769 26.028 26.028 0 0 1-.971-1.859l-.084-.177.084-.179c.299-.632.622-1.252.971-1.858.347-.596.726-1.192 1.126-1.77l.113-.16.196-.018a25.148 25.148 0 0 1 4.198 0l.194.019.113.16a25.136 25.136 0 0 1 2.1 3.628l.083.179-.083.177a24.742 24.742 0 0 1-2.1 3.628l-.113.162-.194.017c-.706.057-1.412.087-2.098.087zm-1.834-.904c1.235.093 2.433.093 3.667 0a24.469 24.469 0 0 0 1.832-3.168 23.916 23.916 0 0 0-1.832-3.168 23.877 23.877 0 0 0-3.667 0 23.743 23.743 0 0 0-1.832 3.168 24.82 24.82 0 0 0 1.832 3.168z"></path>
        </svg>
      ),
    },
    {
      nombre: "Supabase",
      link: "https://supabase.io/docs/",
      svg: (
        <svg
          width="150"
          height="150"
          viewBox="0 0 105 135"
          preserveAspectRatio="xMidYMid meet"
        >
          <g transform="translate(0, 10)">
            <path d="M63.7076 110.284C60.8481 113.885 55.0502 111.912 54.9813 107.314L53.9738 40.0627L99.1935 40.0627C107.384 40.0627 111.952 49.5228 106.859 55.9374L63.7076 110.284Z" />
            <path d="M63.7076 110.284C60.8481 113.885 55.0502 111.912 54.9813 107.314L53.9738 40.0627L99.1935 40.0627C107.384 40.0627 111.952 49.5228 106.859 55.9374L63.7076 110.284Z" />
            <path d="M45.317 2.07103C48.1765 -1.53037 53.9745 0.442937 54.0434 5.041L54.4849 72.2922H9.83113C1.64038 72.2922 -2.92775 62.8321 2.1655 56.4175L45.317 2.07103Z" />
          </g>
        </svg>
      ),
    },
  ];

  let software = [
    {
      nombre: "Photoshop",
      svg: (
        <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 240 234">
          <path d="M197.5,0H42.5A42.46,42.46,0,0,0,0,42.5v149A42.46,42.46,0,0,0,42.5,234h155A42.46,42.46,0,0,0,240,191.5V42.5A42.46,42.46,0,0,0,197.5,0ZM123.6,116.5a34.26,34.26,0,0,1-16.1,12.2c-6.8,2.5-14.3,3.4-22.5,3.4-2.4,0-4,0-5-.1s-2.4-.1-4.3-.1V164a1.24,1.24,0,0,1-1.1,1.4H55.2c-.8,0-1.2-.4-1.2-1.3V61.2c0-.7.3-1.1,1-1.1,1.7,0,3.3,0,5.6-.1s4.9-.1,7.6-.2,5.6-.1,8.7-.2,6.1-.1,9.1-.1c8.2,0,15,1,20.6,3.1A35.71,35.71,0,0,1,120,70.8a31.84,31.84,0,0,1,7.3,11.4,38.28,38.28,0,0,1,2.3,13Q129.6,108.1,123.6,116.5Zm70.9,38.9a25.06,25.06,0,0,1-11.2,8.9c-4.9,2.1-10.9,3.2-18.1,3.2a68.88,68.88,0,0,1-13.6-1.3,40.34,40.34,0,0,1-10.2-3.2,2,2,0,0,1-1.1-1.9V143.7a1.09,1.09,0,0,1,.4-.9.76.76,0,0,1,.9.1,42.81,42.81,0,0,0,12.4,4.9,46.55,46.55,0,0,0,11.8,1.5c3.8,0,6.5-.5,8.3-1.4a4.65,4.65,0,0,0,2.7-4.2c0-1.4-.8-2.7-2.4-4s-4.9-2.8-9.8-4.7a61.18,61.18,0,0,1-14.2-7.2,25.89,25.89,0,0,1-7.6-8.5,21.46,21.46,0,0,1-2.3-10.2A23.52,23.52,0,0,1,143.9,97a24.65,24.65,0,0,1,10.5-9.2c4.7-2.4,10.6-3.5,17.7-3.5a86.21,86.21,0,0,1,12.4.9,35.19,35.19,0,0,1,8.6,2.3,1.76,1.76,0,0,1,1,.9,5,5,0,0,1,.2,1.2v16.3a1.23,1.23,0,0,1-.5,1,2.66,2.66,0,0,1-1.8,0,35.39,35.39,0,0,0-9.6-3.4,52.71,52.71,0,0,0-11.2-1.3,20.13,20.13,0,0,0-6,.7,5.13,5.13,0,0,0-3.1,2,5.3,5.3,0,0,0-.8,2.7,4.45,4.45,0,0,0,1,2.6,11.28,11.28,0,0,0,3.4,2.7c2.3,1.2,4.7,2.3,7.1,3.3a72.43,72.43,0,0,1,15.4,7.3,23.27,23.27,0,0,1,7.9,8.3,21.59,21.59,0,0,1,2.3,10.3A23.27,23.27,0,0,1,194.5,155.4Z" />
          <path d="M98.5,81.2a29.34,29.34,0,0,0-11.8-2c-2.6,0-4.9,0-6.8.1a22.9,22.9,0,0,0-4.1.1V113c1.4.1,2.7.2,3.9.2H85a37.35,37.35,0,0,0,11.5-1.8,17.2,17.2,0,0,0,8.2-5.3c2.1-2.5,3.1-5.9,3.1-10.3a16.46,16.46,0,0,0-2.3-8.9A14.5,14.5,0,0,0,98.5,81.2Z" />
        </svg>
      ),
    },
    {
      nombre: "After Effects",
      svg: (
        <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 319.14 311.16">
          <path
            d="M228.08,136.18a18.73,18.73,0,0,0-17.68,10.1,27.5,27.5,0,0,0-2.93,9.58h28.06c3.46,0,6,0,7.58-.14a6.43,6.43,0,0,0,3.06-1.06v-1.33a15.33,15.33,0,0,0-.8-4.92A17.58,17.58,0,0,0,228.08,136.18Z"
            transform="translate(-0.43 -1.34)"
          />
          <path
            d="M114,140c-1.33-4.12-2.52-8.11-3.85-12.23s-2.53-8-3.59-11.83-2-7.19-2.93-10.38h-.27a162.12,162.12,0,0,1-4.52,17.16c-2,6.38-4,13-6.11,19.68-1.73,6.78-3.86,13-5.85,18.61h33.77c-.8-2.79-1.86-6.11-3.06-9.57S115.19,144,114,140Z"
            transform="translate(-0.43 -1.34)"
          />
          <path
            d="M263.05,1.34H57A56.48,56.48,0,0,0,.43,57.86V256A56.47,56.47,0,0,0,57,312.5h206.1A56.47,56.47,0,0,0,319.57,256V57.86A56.48,56.48,0,0,0,263.05,1.34ZM169.44,220.88H141.65a2,2,0,0,1-2.13-1.46l-10.9-31.91H79.15l-10.1,31.38a2.34,2.34,0,0,1-2.53,1.86h-25c-1.46,0-1.86-.8-1.46-2.39L82.88,95.62c.39-1.33.79-2.53,1.33-4.12A46.62,46.62,0,0,0,85,82.85a1.32,1.32,0,0,1,1.07-1.46h34.44c.93,0,1.59.4,1.73,1.06l48.53,136.3C171.17,220.22,170.77,220.88,169.44,220.88Zm104.39-53.06c-.27,2.53-.4,4.39-.54,5.59a2,2,0,0,1-1.86,1.73c-.8,0-2.26.13-4.39.26a62,62,0,0,1-7.71.4c-3.06,0-6.25-.53-9.7-.53H207.47a29.31,29.31,0,0,0,4.12,11.84,21.07,21.07,0,0,0,9.71,8,41.42,41.42,0,0,0,17,3.33,78.76,78.76,0,0,0,13.83-1.47A50.12,50.12,0,0,0,264,193.89c.66-.53,1.06-.27,1.06,1.06V215.3a6.31,6.31,0,0,1-.27,1.59,3,3,0,0,1-.93.93,56.93,56.93,0,0,1-13.3,4,89.75,89.75,0,0,1-18.88,1.6c-10.1,0-18.61-1.6-25.53-4.66a44.7,44.7,0,0,1-16.75-12.63,48.76,48.76,0,0,1-9.18-17.42,69,69,0,0,1,.53-40.56,54.38,54.38,0,0,1,10-18.21,48.08,48.08,0,0,1,16.09-12.63c6.25-3.06,13.69-4.13,22.2-4.13a48.07,48.07,0,0,1,20.62,4.13,36.67,36.67,0,0,1,14,10.63,48.91,48.91,0,0,1,8,15.16,52.55,52.55,0,0,1,2.52,16.22C274.09,162.51,274,165.3,273.83,167.82Z"
            transform="translate(-0.43 -1.34)"
          />
        </svg>
      ),
    },
    {
      nombre: "Premiere Pro",
      svg: (
        <svg id="Capa_1" data-name="Capa 1" viewBox="0 0 240 234">
          <path
            d="M357.5,83h-155A42.46,42.46,0,0,0,160,125.5v149A42.46,42.46,0,0,0,202.5,317h155A42.46,42.46,0,0,0,400,274.5v-149A42.46,42.46,0,0,0,357.5,83ZM286.6,199.5a34.26,34.26,0,0,1-16.1,12.2c-6.8,2.5-14.3,3.4-22.5,3.4-2.4,0-4,0-5-.1s-2.4-.1-4.3-.1V247a1.24,1.24,0,0,1-1.1,1.4H218.2c-.8,0-1.2-.4-1.2-1.3h0V144.2c0-.7.3-1.1,1-1.1,1.7,0,3.3,0,5.6-.1s4.9-.1,7.6-.2,5.6-.1,8.7-.2,6.1-.1,9.1-.1c8.2,0,15,1,20.6,3.1a35.71,35.71,0,0,1,13.4,8.2,31.84,31.84,0,0,1,7.3,11.4,38.28,38.28,0,0,1,2.3,13Q292.6,191.1,286.6,199.5Zm68.2-12c0,.8-.5,1.1-1.6,1.1a43.48,43.48,0,0,0-10.8,1,41.15,41.15,0,0,0-8.4,2.7,15.55,15.55,0,0,0-5.1,3.7v51c0,1-.4,1.4-1.3,1.4H307.9a1.38,1.38,0,0,1-1.6-1.2V191.4c0-2.4,0-4.9-.1-7.5s-.1-5.2-.2-7.8c0-2.3-.2-4.5-.4-6.8a.92.92,0,0,1,.7-1.1c0-.1.2-.1.3,0h17.5a2.25,2.25,0,0,1,2.1,1.6,10.15,10.15,0,0,1,.6,2.5c.2,1,.4,2.1.5,3.1s.2,2.3.2,3.6a37.22,37.22,0,0,1,10.7-8.6,31,31,0,0,1,15.2-3.9,1.24,1.24,0,0,1,1.4,1.1Z"
            transform="translate(-160 -83)"
          />
          <path
            d="M261.5,164.2a29.34,29.34,0,0,0-11.8-2c-2.6,0-4.9,0-6.8.1a22.9,22.9,0,0,0-4.1.1h0V196c1.4.1,2.7.2,3.9.2H248a37.35,37.35,0,0,0,11.5-1.8,17.2,17.2,0,0,0,8.2-5.3c2.1-2.5,3.1-5.9,3.1-10.3a16.46,16.46,0,0,0-2.3-8.9A14.5,14.5,0,0,0,261.5,164.2Z"
            transform="translate(-160 -83)"
          />
        </svg>
      ),
    },
    {
      nombre: "Illustrator",
      svg: (
        <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 240 234">
          <path d="M197.5,0H42.5A42.46,42.46,0,0,0,0,42.5v149A42.46,42.46,0,0,0,42.5,234h155A42.46,42.46,0,0,0,240,191.5V42.5A42.46,42.46,0,0,0,197.5,0ZM147,165.3H126.1a1.51,1.51,0,0,1-1.6-1.1l-8.2-23.8H79.1l-7.6,23.5a1.75,1.75,0,0,1-1.9,1.4H50.8c-1.1,0-1.4-.6-1.1-1.8L81.9,70.8c.3-1,.6-2.1,1-3.3a34.93,34.93,0,0,0,.6-6.5,1,1,0,0,1,.8-1.1h25.9c.8,0,1.2.3,1.3.8l36.5,103C148.3,164.8,148,165.3,147,165.3Zm34-1.5c0,1.1-.4,1.6-1.3,1.6H160.1a1.4,1.4,0,0,1-1.5-1.6v-77c0-1,.4-1.4,1.3-1.4h19.8c.9,0,1.3.5,1.3,1.4Zm-2.1-90.3a11.76,11.76,0,0,1-9.1,3.5,12.38,12.38,0,0,1-8.9-3.5,13,13,0,0,1-3.4-9.2,11.77,11.77,0,0,1,3.6-8.9,12.81,12.81,0,0,1,8.9-3.5c3.9,0,6.9,1.2,9.1,3.5a12.62,12.62,0,0,1,3.3,8.9A12.65,12.65,0,0,1,178.9,73.5Z" />
          <path d="M105.3,104.3c-1-3.1-1.9-6.1-2.9-9.2s-1.9-6-2.7-8.9-1.5-5.4-2.2-7.8h-.2a122.78,122.78,0,0,1-3.4,12.9c-1.5,4.8-3,9.8-4.6,14.8-1.4,5.1-2.9,9.8-4.4,14h25.4c-.6-2.1-1.4-4.6-2.3-7.2S106.2,107.3,105.3,104.3Z" />
        </svg>
      ),
    },
    {
      nombre: "Audition",
      svg: (
        <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 320 312">
          <path
            d="M111,139.28c-1.37-4.12-2.49-8.11-3.87-12.23s-2.49-8-3.62-11.86-2-7.24-3-10.36h-.25a173.52,173.52,0,0,1-4.5,17.23c-2,6.36-4,13.1-6.11,19.72a185.16,185.16,0,0,1-5.74,18.59h33.82c-.75-2.75-1.87-6.12-3.12-9.61S112.2,143.27,111,139.28Z"
            transform="translate(0 -0.25)"
          />
          <path
            d="M263.34.25H56.66A56.61,56.61,0,0,0,0,56.91V255.59a56.61,56.61,0,0,0,56.66,56.66H263.34A56.62,56.62,0,0,0,320,255.59V56.91A56.62,56.62,0,0,0,263.34.25Zm-96.48,220H139a2,2,0,0,1-2.12-1.49L125.68,187H76.13L66,218.4a2.3,2.3,0,0,1-2.5,1.87H38.44c-1.5,0-1.87-.74-1.5-2.37L79.87,94.6a42.84,42.84,0,0,1,1.38-4.37,38.74,38.74,0,0,0,1.12-8.49,1.35,1.35,0,0,1,1.12-1.49h34.57c.88,0,1.63.37,1.75,1.12l48.43,136.78C168.61,219.65,168.24,220.27,166.86,220.27ZM270,220.4H247.11a2.34,2.34,0,0,1-2.49-1.5l-.75-3.37a10.18,10.18,0,0,1-.25-2.74,38,38,0,0,1-15.1,8.23,54.13,54.13,0,0,1-14.86,2,43.43,43.43,0,0,1-14.47-2.25,28.38,28.38,0,0,1-11.36-7.36,33.21,33.21,0,0,1-7.49-13,60.84,60.84,0,0,1-2.62-19V115.32a1.54,1.54,0,0,1,1.37-1.75h25.84a1.53,1.53,0,0,1,1.75,1.37v63c0,5.86,1.37,10.48,3.86,13.85s7.74,5.11,13.73,5.11a25.35,25.35,0,0,0,9.11-1.62,31,31,0,0,0,8.37-4.37V115.19c0-.87.62-1.5,1.87-1.5h25.46a1.3,1.3,0,0,1,1.5,1.13.44.44,0,0,0-.13.37v81.74c0,3.63,0,6.74.13,9.62s.24,5.24.37,7.36.38,3.37.5,4.74S271.08,220.4,270,220.4Z"
            transform="translate(0 -0.25)"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className={estilo.sobre}>
      <MetaDecorator
        titulo={"Sobre Mi"}
        subtitulo={"Sobre Mi"}
        descripcion={
          "Soy un Desarrollador Frontend muy comprometido con la mejora continua de mi trabajo y tengo un gran interés en mantenerme constantemente actualizado en las últimas tendencias y tecnologías en el Desarrollo Web. Tengo conocimientos en HTML, CSS, JavaScript, React y Supabase."
        }
        url={"https://bryanticonavalencia.site/sobre-mi"}
        canonical={"https://bryanticonavalencia.site/sobre-mi"}
      ></MetaDecorator>
      <div className={estilo.sobre_contenedor}>
        <div className={estilo.sobre_info}>
          <div className={estilo.sobre_foto}>
            <img src={foto} alt="foto" />
          </div>

          <ul>
            {informacion.map((e, i) => (
              <li key={i}>
                {e.svg} {e.dato}
              </li>
            ))}
          </ul>
        </div>

        <div className={estilo.sobre_detalles}>
          <p>
            Soy un Desarrollador Frontend muy comprometido con la mejora
            continua de mi trabajo y tengo un gran interés en mantenerme
            constantemente actualizado en las últimas tendencias y tecnologías
            en el Desarrollo Web. Tengo conocimientos en HTML, CSS, JavaScript,
            React y Supabase.
          </p>

          <div className={estilo.educacion}>
            <h3>educación</h3>

            <div className={estilo.flex_educacion}>
              {educacion.map((e, i) => (
                <div key={i} className={estilo.tarjeta_educacion}>
                  <h4>{e.año}</h4>
                  <p>{e.centro_estudios}</p>

                  <div className={estilo.estado}>
                    <p>{e.estado ? "Finalizado" : "No Finalizado"}</p>
                  </div>

                  <p>{e.area}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={estilo.sobre_experiencia}>
          <div className={estilo.experiencia}>
            <h3>Habilidades</h3>

            <div className={estilo.flex_experiencia}>
              {habilidades.map((e, i) => (
                <div key={i} className={estilo.tarjeta_experiencia}>
                  {e.svg}
                  <p>{e.nombre}</p>
                </div>
              ))}
            </div>
          </div>

          <div className={estilo.experiencia}>
            <h3>Sotfware</h3>

            <div className={estilo.flex_experiencia}>
              {software.map((e, i) => (
                <div key={i} className={estilo.tarjeta_experiencia}>
                  {e.svg}
                  <p>{e.nombre}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sobre;
